export const columns = [
  {
    dataField: 'name',
    sortBy: 'name',
    text: 'Report',
    sortable: true,
  },
  {
    dataField: 'frequency',
    text: 'Frequency',
    sortBy: 'frequency',
    sortable: true,
  },
  {
    dataField: 'time_period',
    text: 'Time Period',
  },
  {
    dataField: 'downloaded_at',
    text: 'Downloaded',
    sortBy: 'downloaded_at',
    sortable: false,
  },
  {
    dataField: 'version_size',
    text: 'Size',
    sortBy: 'current_version_file_size',
    sortable: true,
  },
  {
    dataField: 'actions',
    text: '',
  },
];
